var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.104 14.6667C18.804 14.619 17.652 14.2857 17.352 14.1548L14.868 21.869L11.16 20.5238L13.8 13.6548L10.14 9.52381L13.2 7.78571C13.74 9.13095 14.604 10.2619 15.744 11.1905C16.884 12.119 18.192 12.7024 19.656 12.9286L21 8.84524L19.272 8.28571L18.648 10.1905C17.856 9.85714 17.16 9.35714 16.56 8.71428C15.96 8.05952 15.528 7.29762 15.264 6.44048L14.868 5.15476C14.724 4.67857 14.448 4.29762 14.052 4.0119C13.656 3.7381 13.2 3.57143 12.756 3.53571C12.288 3.5 11.832 3.57143 11.4 3.82143L7.2 6.22619C6.756 6.47619 6.432 6.83333 6.228 7.28571C6 7.7381 5.952 8.19048 6 8.67857C6.048 9.16667 6.312 9.59524 6.648 9.96429L10.932 14.381L8.904 19.6905L0.564 16.7262L0 18.4048L16.848 24.5C17.784 24.8333 18.78 25 19.836 25C20.58 25 21.312 24.9048 22.032 24.7262C22.74 24.5357 23.4 24.2738 24 23.9405L22.644 22.619C21.744 23.0119 20.808 23.2143 19.836 23.2143C19.044 23.2143 18.252 23.0833 17.46 22.8214L16.56 22.4881L19.104 14.6667ZM20.4 2.38095C20.4 3.70238 19.332 4.7619 18 4.7619C16.668 4.7619 15.6 3.70238 15.6 2.38095C15.6 1.05952 16.68 0 18 0C19.32 0 20.4 1.07143 20.4 2.38095Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkier);
export default __webpack_public_path__ + "static/media/skier.2eede77594c4f38c573bd839a60338be.svg";
export { ForwardRef as ReactComponent };